import { useState, useEffect } from "react";
function measureVp(width) {
    if (width >= 1600)
        return "hd";
    if (width >= 1280)
        return "desktop";
    if (width >= 760)
        return "tablet";
    return "mobile";
}
export function useViewport(ref) {
    const [vp, setVp] = useState("desktop");
    useEffect(() => {
        const el = ref.current;
        if (!el)
            return;
        setVp(measureVp(el.getBoundingClientRect().width));
        const ro = new ResizeObserver((entries) => setVp(measureVp(entries[0].contentRect.width)));
        ro.observe(el);
        return () => ro.disconnect();
    }, [ref]);
    return vp;
}
